export default {
  title: 'ギフト一覧',
  addGift: 'ギフト追加',
  editGift: 'ギフト編集',
  giftName: 'ギフト名',
  giftNo: 'ギフト番号',
  giftType: 'ギフトタイプ',
  giftCategory: 'ギフトカテゴリ',
  virtualGift: '仮想ギフト',
  physicalGift: '実物ギフト',
  id: 'ID',
  giftInfo: 'ギフト情報',
  giftPrice: 'ギフト価格',
  giftSpec: 'ギフト仕様',
  detail: '詳細',
  singleSpec: '単一仕様',
  multiSpec: '複数仕様',
};
